export { ClassicCVEducation } from './ClassicCVEducation';
